import type { Dispatch, PropsWithChildren, SetStateAction } from "react";
import React from "react";
import type {
  DocumentCollectionDetails,
  DocumentCollectionOperations,
  DocumentIdentifier,
} from "../../../../api/types/documentCollectionTypes";
import type { DocumentAccessOption } from "./documents-view/documentAccessHelper";

interface Props {
  documentCollection: DocumentCollectionDetails;
  hasPermissionsToManage: boolean;
  investorPortalEnabled: boolean;
  sentInvites: Record<string, Date>;
  setSentInvites: Dispatch<SetStateAction<Record<string, Date>>>;
  onChangeDocumentCollectionStatus: (operation: DocumentCollectionOperations) => void;
  onChangeDocumentsStatus: (
    operation: DocumentCollectionOperations,
    postMessageRequestIds: string[],
    documentsInfo: string
  ) => void;
  onChangeDocumentsAccess: (documents: DocumentIdentifier[], currentDocumentsAccess: DocumentAccessOption[]) => void;
}

const DocumentCollectionContext = React.createContext<Props | undefined>(undefined);

export const DocumentCollectionContextProvider = ({ children, ...value }: PropsWithChildren<Props>) => (
  <DocumentCollectionContext value={value}>{children}</DocumentCollectionContext>
);

export default DocumentCollectionContext;
